import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'pos-orbit',
  templateUrl: './pos-orbit.component.html',
  styleUrl: './pos-orbit.component.css',
})
export class PosOrbitComponent {}
